import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Apply consistent spacing and padding for actions content inside a Card
 */
export default function CardContent({
  children,
  classes,
  elementRef,
  size = 'md',
  ...htmlAttributes
}) {
  return _jsx("div", {
    "data-component": "CardContent",
    ...htmlAttributes,
    ref: downcastRef(elementRef),
    className: classnames({
      'p-3 space-y-4': size === 'md',
      // Default
      'p-2 space-y-3': size === 'sm',
      'p-4 space-y-6': size === 'lg'
    }, classes),
    children: children
  });
}
//# sourceMappingURL=CardContent.js.map